function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSberpayPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "79px",
    height: "38px",
    viewBox: "0 0 79 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,84.705882%,0%)",
      fillOpacity: 1
    },
    d: "M 19.011719 37.859375 L 59.9375 37.859375 C 70.328125 37.859375 78.753906 29.40625 78.753906 18.976562 C 78.753906 8.542969 70.328125 0.0898438 59.9375 0.0898438 L 19.011719 0.0898438 C 8.621094 0.0898438 0.195312 8.542969 0.195312 18.976562 C 0.195312 29.40625 8.621094 37.859375 19.011719 37.859375 Z M 19.011719 37.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.578125 20.980469 L 39.578125 25.214844 L 37.160156 25.214844 L 37.160156 11.621094 L 41.664062 11.621094 C 45.941406 11.621094 47.757812 13.15625 47.757812 16.226562 C 47.757812 19.390625 45.628906 20.980469 41.664062 20.980469 Z M 39.578125 13.855469 L 39.578125 18.746094 L 41.851562 18.746094 C 44.09375 18.746094 45.253906 18.007812 45.253906 16.164062 C 45.253906 14.496094 44.246094 13.855469 41.890625 13.855469 Z M 39.578125 13.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 49.035156 16.183594 C 49.671875 15.707031 50.832031 15.3125 52.5 15.3125 C 55.324219 15.3125 56.714844 16.285156 56.714844 18.808594 L 56.714844 25.214844 L 54.589844 25.214844 L 54.589844 23.464844 C 54.125 24.589844 52.945312 25.367188 51.394531 25.367188 C 49.441406 25.367188 48.285156 24.261719 48.285156 22.359375 C 48.285156 20.144531 49.886719 19.523438 52.265625 19.523438 L 54.453125 19.523438 L 54.453125 19.097656 C 54.453125 17.71875 53.796875 17.292969 52.5 17.292969 C 50.71875 17.292969 49.695312 17.992188 49.039062 19.019531 Z M 54.449219 21.785156 L 54.449219 21 L 52.535156 21 C 51.199219 21 50.5625 21.253906 50.5625 22.125 C 50.5625 22.863281 51.101562 23.328125 52.109375 23.328125 C 53.636719 23.328125 54.351562 22.457031 54.449219 21.785156 Z M 54.449219 21.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 57.835938 15.507812 L 60.359375 15.507812 L 63.007812 22.164062 L 65.171875 15.507812 L 67.570312 15.507812 L 63.703125 26.242188 C 62.851562 28.570312 61.984375 29.09375 60.707031 29.09375 C 60.105469 29.09375 59.445312 28.921875 59.160156 28.667969 L 59.160156 26.550781 C 59.46875 26.855469 59.886719 27.03125 60.320312 27.039062 C 61.015625 27.039062 61.535156 26.570312 61.90625 25.265625 Z M 57.835938 15.507812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 15.019531 16.195312 L 15.019531 19.175781 L 18.957031 21.65625 L 28.382812 14.691406 C 28.050781 13.960938 27.636719 13.265625 27.144531 12.628906 L 18.957031 18.671875 Z M 15.019531 16.195312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 26.910156 18.746094 C 26.910156 18.816406 26.910156 18.890625 26.910156 18.960938 C 26.917969 22.636719 24.425781 25.84375 20.871094 26.730469 C 17.316406 27.617188 13.621094 25.960938 11.90625 22.710938 C 10.195312 19.460938 10.914062 15.460938 13.644531 13.011719 C 16.375 10.566406 20.417969 10.300781 23.441406 12.375 L 25.460938 10.886719 C 21.699219 7.839844 16.335938 7.808594 12.542969 10.816406 C 8.75 13.820312 7.535156 19.066406 9.617188 23.441406 C 11.699219 27.820312 16.527344 30.167969 21.242188 29.097656 C 25.957031 28.023438 29.304688 23.820312 29.304688 18.96875 C 29.304688 18.34375 29.246094 17.71875 29.136719 17.105469 Z M 26.910156 18.746094 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSberpayPayment);
export default __webpack_public_path__ + "static/media/sberpay-payment.4eb5b3fa2bee807a8943233caf8a2b25.svg";
export { ForwardRef as ReactComponent };